'use client'

import { createContext } from 'react'
import { UiPermission } from './types'

export type CookieNotificationContext = {
  closePopover: () => void
  openSettings: () => void
  closeSettings: () => void
  acceptAllConsent: () => Promise<void>
  declineAllConsent: () => Promise<void>
  updateConsent: (id: string, value: boolean) => Promise<void>
  permissionState: UiPermission
  popoverRef: React.RefObject<HTMLDivElement | null>
  settingsRef: React.RefObject<HTMLDialogElement | null>
}

export const CookieNotificationContext =
  createContext<CookieNotificationContext>({
    closePopover: () => {
      throw new Error('closePopover not implemented')
    },
    openSettings: () => {
      throw new Error('openSettings not implemented')
    },
    closeSettings: () => {
      throw new Error('closeSettings not implemented')
    },
    acceptAllConsent: () => {
      throw new Error('acceptAllConsent not implemented')
    },
    declineAllConsent: () => {
      throw new Error('declineAllConsent not implemented')
    },
    updateConsent: () => {
      throw new Error('updateConsent not implemented')
    },
    permissionState: {},
    popoverRef: { current: null },
    settingsRef: { current: null },
  })
